import { render } from "./HomeA.vue?vue&type=template&id=89bf985c"
import script from "./HomeA.vue?vue&type=script&lang=js"
export * from "./HomeA.vue?vue&type=script&lang=js"

import "./HomeA.vue?vue&type=style&index=0&id=89bf985c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__